<template>
  <div class="container">
    <p class="titleMain">Карточка клиента</p>
    <p v-if="clientInfo.title" class="titleMain">{{clientInfo.title}}</p>
    <p v-if="clientInfo.name" class="titleMain">{{clientInfo.name}}</p>
    <div class="client-info">
      <!-- <p class="client-info__code" v-if="clientCode != ''"><span>КОД ИЭ</span> {{clientCode}}</p> -->
      <label>
        <span>Регион:</span>
        <input :disabled="!clientInfoEdit" type="text" v-model="clientInfo.region"> 
      </label>
      <label>
        <span>Город:</span>
        <input :disabled="!clientInfoEdit" type="text" v-model="clientInfo.city"> 
      </label>
      <label>
        <span>Телефон:</span>
        <input :disabled="!clientInfoEdit" type="text" v-model="clientInfo.phone">  
      </label>
      <label>
        <span>E-mail:</span>
        <input :disabled="!clientInfoEdit" type="text" v-model="clientInfo.email"> 
      </label>
      <div class="client-info-button-block">
        <p v-if="!clientInfoEdit" class="edit" @click="editProfile()"></p>
        <p v-if="clientInfoEdit" class="save" @click="saveProfile()"></p>
        <p v-if="clientInfoEdit" class="cancel" @click="cancel()"></p>
      </div>
      
    </div>  
   <PresentationItem
    v-for="(client, index) in presentationsList"
      :key="index"
      :clientInfo="client"
   ></PresentationItem>
  </div>
</template>
<script>
import PresentationItem from "@/components/presentation/presentationItem";
export default {
    components: {PresentationItem},
   data: function(){
        return {
            clientInfo: {},
            clientInfoEdit: false,
            presentationsList: []
        }
    }, 
    methods: {
        startComponent(){
            if(this.$localStorageGet('clientCardInfo')){
                this.clientInfo = this.$localStorageGet('clientCardInfo')

                this.$store.dispatch('GET_CLIENT_PRESENTATIONS', this.clientInfo.id).then(r=>{
                    this.presentationsList = r.data.data;
                })
            }else{
                this.$makeToast(
                    "Ошибка!",
                    "danger",
                    "В localStorage нет информации о клиенте, скорее всего переход был не со страницы клиентов"
                );
            }

        },
        editProfile(){
            this.clientInfoEdit = true;
        },
        cancel(){
            this.clientInfoEdit = false;
            this.startComponent();
        },
        saveProfile(){
            let obj = {
               clientId: this.clientInfo.id,
               title: this.clientInfo.title,
               city: this.clientInfo.city,
               region: this.clientInfo.region,
               phone: this.clientInfo.phone,
               email: this.clientInfo.email,
               description: this.clientInfo.description
            }
            this.$store.dispatch('EDIT_CLIENT_INFO', obj).then(r=>{
                this.$localStorageSet('clientCardInfo', this.clientInfo)
                this.clientInfoEdit = false;
                this.startComponent();
                this.$makeToast(
                    "Отлично!",
                    "success",
                    "Данные клиента успешно обновлены!"
                );
            })
        }
    },
    created(){
      this.startComponent()
    },
     beforeRouteLeave(to, from, next) {
       console.log('Сваливаем с карточки')
       this.$localStorageDelete('clientCardInfo')
       next(true)
      // вызывается перед переходом от пути, соответствующего текущему компоненту;
      // имеет доступ к контексту экземпляра компонента `this`.
    }
    
}
</script>
<style lang="scss">


</style>